import { useEffect, useRef, useCallback } from 'react';
import { useElementCache } from './hooks/useElementCache';

const GradientPainter = ({
  speed = 0.01,
  amplitude = 0.3,
  enabled = true,
  selector = '.gradient-paint'
}) => {
  const timeRef = useRef(0);
  const animationIdRef = useRef(null);
  const { elements, updateCache } = useElementCache(selector, enabled);

  const animate = useCallback(() => {
    if (!enabled || elements.length === 0) return;

    timeRef.current += speed;

    const sinTime = Math.sin(timeRef.current);
    const cosTime = Math.cos(timeRef.current * 0.7);

    elements.forEach(({ element, width, height }) => {
      if (width > 0 && height > 0) {
        const posX = sinTime * (width * amplitude);
        const posY = cosTime * (height * amplitude);

        element.style.setProperty('--posX', posX);
        element.style.setProperty('--posY', posY);
      }
    });

    animationIdRef.current = requestAnimationFrame(animate);
  }, [speed, amplitude, enabled, elements]);

  useEffect(() => {
    if (!enabled) return;

    animate();

    return () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
    };
  }, [animate, enabled]);

  useEffect(() => {
    if (enabled) {
      updateCache();
    }
  }, [enabled, updateCache]);

  return null;
};

export default GradientPainter;
